// QuantitySelectionModal.tsx
import { useState } from 'react';
import '../styles/variables.css'

type Props = {
    ranges: Array<{description: string; price: number}>;
    onSelect: (quantity: number, price: number) => void;
    onClose: () => void;
    serviceName?: string;
    availableQuantity: number;
};

export const QuantitySelectionModal = ({
  ranges,
  onSelect,
  onClose,
  serviceName = 'УСЛУГА',
  availableQuantity
}: Props) => {
  const [selectedPrice, setSelectedPrice] = useState(ranges[0]?.price || 0);
  const [selectedQuantity, setSelectedQuantity] = useState(1);

  const calculateTotal = () => selectedPrice * selectedQuantity;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2 className="service-title">{serviceName}</h2>
        </div>

        <div className="quantity-options">
          {ranges.map((range) => (
            <button
              key={range.price}
              className={`quantity-btn ${selectedPrice === range.price ? 'selected' : ''}`}
              onClick={() => setSelectedPrice(range.price)}
            >
              <div className="option-description">{range.description}</div>
            </button>
          ))}
        </div>

        <div className="tables-control">
          <h3 className="modal-subtitle">Выберите количество</h3>         
          <div className="table-counter">
            <button 
              className="counter-btn" 
              onClick={() => setSelectedQuantity(Math.max(1, selectedQuantity - 1))}
              disabled={selectedQuantity === 1}
            >
              -
            </button>
            <span className="counter-value">{selectedQuantity}</span>
            <button 
              className="counter-btn" 
              onClick={() => setSelectedQuantity(prev => prev + 1)}
              disabled={selectedQuantity >= availableQuantity}
            >
              +
            </button>
          </div>
        </div>

        <div className="duration-price">
          <span className="duration">Сумма:</span>
          <span className="price">{calculateTotal().toLocaleString()} ₽</span>
        </div>

        <div className="modal-actions">
          <button className="btn-cancel" onClick={onClose}>
            Отменить
          </button>
          <button
            className="btn-confirm"
            onClick={() => onSelect(selectedQuantity, selectedPrice)}
          >
            Подтвердить
          </button>
        </div>

        <style>{`
          .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
          }

          .modal-content {
            background: white;
            border-radius: 20px;
            padding: 24px;
            width: 90%;
            max-width: 375px;
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
          }

          .modal-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 32px;
          }

          .service-title {
            font-size: 24px;
            color: #1A1A1A;
            font-weight: 700;
            text-transform: uppercase;
            width: 100%;
            text-align: center;
          }

          .quantity-options {
            display: flex;
            flex-wrap: wrap;
            gap: 12px;
            margin-bottom: 24px;
            justify-content: center;
          }

          .quantity-btn {
            width: 100px;
            height: 48px;
            border: 2px solid #E0E0E0;
            border-radius: 12px;
            font-size: 12px;
            transition: all 0.2s;
            background: white;
            padding: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .quantity-btn.selected {
            background: #115293;
            color: white;
            border-color: #115293;
          }

          .option-description {
            word-break: break-word;
            line-height: 1.2;
            text-align: center;
            background: #115293 !important;
          }

          .tables-control {
            margin: 20px 0;
            text-align: center;
          }

          .modal-subtitle {
            font-size: 18px;
            color: #666;
            margin-bottom: 16px;
          }

          .table-counter {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 15px;
            margin-top: 10px;
          }

          .counter-btn {
            width: 40px;
            height: 40px;
            border: 2px solid #115293;
            border-radius: 8px;
            background: none;
            font-size: 20px;
            color: #115293;
            cursor: pointer;
            transition: all 0.2s;
          }

          .counter-btn:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }

          .counter-btn:hover:not(:disabled) {
            background: #115293;
            color: white;
          }

          .counter-value {
            font-size: 24px;
            font-weight: 600;
            min-width: 50px;
            text-align: center;
          }

          .duration-price {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 24px 0;
            padding: 16px 0;
            border-top: 1px solid #EEE;
            border-bottom: 1px solid #EEE;
          }

          .duration {
            font-size: 18px;
            color: #666;
          }

          .price {
            font-size: 24px;
            font-weight: 700;
            color: #1A1A1A;
          }

          .modal-actions {
            display: flex;
            gap: 16px;
            margin-top: 24px;
          }

          .btn-cancel {
            flex: 1;
            padding: 16px;
            border: none;
            border-radius: 8px;
            background: #F5F5F5;
            color: #666;
            font-size: 16px;
          }

          .btn-confirm {
            flex: 1;
            padding: 16px;
            border: none;
            border-radius: 8px;
            background: #115293;
            color: white;
            font-size: 16px;
            font-weight: 600;
          }
        `}</style>
      </div>
    </div>
  );
};